<template>
  <!--Logo start-->
  <div class="logo-main d-flex align-items-center justify-content-center me-2" style="width: 34px; height: 34px; border-radius: 10px; background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%); color: #ffffff; box-shadow: 0 3px 10px rgba(37, 99, 235, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.25); flex-shrink: 0;">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 20V9.5z"/>
      <path d="M9 21V12h6v9"/>
      <circle cx="12" cy="7.5" r="1" fill="currentColor"/>
    </svg>

    <!--<img width="30" height="30" src="@/assets/images/logo.svg" alt="Логотип" />-->
  </div>
  <!--Logo End-->
</template>

<script>
export default {
  props: {
    color: { type: Boolean, default: false }
  }
}
</script>
